import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";

const StatBox = ({ title, subtitle, icon }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      p="20px 24px" // Slightly reduced padding to prevent text bleed
      sx={{
        backgroundColor: colors.primary[400],
        borderRadius: "12px",
        // Dynamic border to ensure visibility in Light Mode
        border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.1)"}`,
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        cursor: "pointer",
        overflow: "hidden",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 12px 30px rgba(0,0,0,0.4)"
              : "0 12px 30px rgba(0,0,0,0.08)",
        },
      }}
    >
      {}
      {/* TOP SECTION: Raw Icon & Optional Increase Badge */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {/* Raw icon without background border/enclosure */}
        <Box display="flex" alignItems="center" justifyContent="center">
          {icon}
        </Box>
      </Box>

      {}
      {/* BOTTOM SECTION: Text Data */}
      <Box mt="16px">
        <Typography
          variant="h3"
          fontWeight="800"
          sx={{
            color: colors.gray[100],
            mb: "4px",
            letterSpacing: "-0.5px",
            lineHeight: 1.2, // Tighter line-height to prevent bleeding
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="subtitle2"
          fontWeight="600"
          sx={{ color: colors.greenAccent[500] }}
        >
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatBox;
